import i18next from "i18next";
import { Icon } from "Components/UI";
import { iconFileByFilename } from "Utils/Icons";
import { HistoryFileContentRecord } from "Data/interfaces/History/IHistoryFileRecord";
import { HistoryFileActionEnum } from "Data/interfaces/History/IHistoryFileApi";
import { getDisciplineIcon } from "Utils/ObraUtils";
import {
  CurveLink,
  FileDescriptionContainer,
  FileMoveContainer,
  FileNameContainer,
  FileStatusValue,
  FilesContentContainer,
  FilesStatusContainer,
} from "../styles";

export const filesContentOptions: HistoryFileContentRecord = {
  [HistoryFileActionEnum.StatusChanged]: ({ item }) => {
    const isOldBloqued = item.From?.DisplayValue?.toLowerCase()?.includes('bloqueado');
    const isNewBloqued = item.To?.DisplayValue?.toLowerCase()?.includes('bloqueado');

    return (
      <FilesContentContainer>
        <FilesStatusContainer>
          <span className="title">{i18next.t('listagemArquivos:history.statusPrefix')}</span>
          <FileStatusValue isbloqued={`${isOldBloqued}`} isold="true">
            {item.From?.DisplayValue}
          </FileStatusValue>
          <Icon
            icon="rightArrow"
            customSize={16}
            className="arrowIcon"
          />
          <FileStatusValue isbloqued={`${isNewBloqued}`}>
            {item.To?.DisplayValue}
          </FileStatusValue>
        </FilesStatusContainer>
        <FileNameContainer>
          <Icon
            icon={iconFileByFilename(item.ItemName)}
            customSize={12}
            className="assitantIcon"
          />
          <span className="assistantText">{item.ItemName}</span>
        </FileNameContainer>
      </FilesContentContainer>
    )
  },
  [HistoryFileActionEnum.FileDownloaded]: ({ item }) => {
    return (
      <FilesContentContainer>
        <FileNameContainer>
          <Icon
            icon={iconFileByFilename(item.ItemName)}
            customSize={12}
            className="assitantIcon"
          />
          <span className="assistantText">{item.ItemName}</span>
        </FileNameContainer>
      </FilesContentContainer>
    )
  },
  [HistoryFileActionEnum.FileDeleted]: ({ item }) => {
    return (
      <FilesContentContainer>
        <FileNameContainer isdisabled="true">
          <Icon
            icon={iconFileByFilename(item.ItemName)}
            customSize={12}
            className="assitantIcon"
          />
          <span className="assistantText">{item.ItemName}</span>
        </FileNameContainer>
      </FilesContentContainer>
    )
  },
  [HistoryFileActionEnum.FileMoved]: ({ item }) => {
    return (
      <FilesContentContainer>
        <FileMoveContainer>
          <div className="header">
            <FileNameContainer>
              <Icon
                icon="arquivar"
                customSize={12}
                className="assitantIcon"
              />
              <span className="assistantText">{item.To?.DisplayValue}</span>
            </FileNameContainer>
          </div>
          <div className="footer">
            <CurveLink><div className="curve" /></CurveLink>
            <FileNameContainer>
              <Icon
                icon={iconFileByFilename(item.ItemName)}
                customSize={12}
                className="assitantIcon"
              />
              <span className="assistantText">{item.ItemName}</span>
            </FileNameContainer>
          </div>
        </FileMoveContainer>
      </FilesContentContainer>
    )
  },
  [HistoryFileActionEnum.FolderCreated]: ({ item }) => {
    return (
      <FilesContentContainer>
        <FileMoveContainer>
          <div className="header">
            <FileNameContainer>
              <Icon
                icon={getDisciplineIcon(item.ParentName)}
                customSize={12}
                className="assitantIcon"
              />
              <span className="assistantText">{item.ParentName}</span>
            </FileNameContainer>
          </div>
          <div className="footer">
            <CurveLink><div className="curve" /></CurveLink>
            <FileNameContainer>
              <Icon
                icon="arquivar"
                customSize={12}
                className="assitantIcon"
              />
              <span className="assistantText">{item.ItemName}</span>
            </FileNameContainer>
          </div>
        </FileMoveContainer>
      </FilesContentContainer>
    );
  },
  [HistoryFileActionEnum.FolderDeleted]: ({ item }) => {
    return (
      <FilesContentContainer>
        <FileMoveContainer>
          <div className="header">
            <FileNameContainer>
              <Icon
                icon={iconFileByFilename(item.ParentName)}
                customSize={12}
                className="assitantIcon"
              />
              <span className="assistantText">{item.ParentName}</span>
            </FileNameContainer>
          </div>
          <div className="footer">
            <CurveLink><div className="curve" /></CurveLink>
            <FileNameContainer isdisabled="true">
              <Icon
                icon="arquivar"
                customSize={12}
                className="assitantIcon"
              />
              <span className="assistantText">{item.ItemName}</span>
            </FileNameContainer>
          </div>
        </FileMoveContainer>
      </FilesContentContainer>
    )
  },
  [HistoryFileActionEnum.FileRenamed]: ({ item }) => {
    return (
      <FilesContentContainer>
        <FileNameContainer>
          <Icon
            icon={iconFileByFilename(
              typeof item?.To?.DisplayValue === 'string' ? item.To.DisplayValue : ''
            )}
            customSize={12}
            className="assistantIcon"
          />
          <span className="assistantText">{item?.To?.DisplayValue ?? i18next.t('listagemArquivos:history.unknownOldName')}</span>
        </FileNameContainer>
        <FileNameContainer isdisabled="true">
          <Icon
            icon={iconFileByFilename(
              typeof item?.From?.DisplayValue === 'string' ? item.From.DisplayValue : ''
            )}
            customSize={12}
            className="assistantIcon"
          />
          <span className="assistantText">{item?.From?.DisplayValue ?? i18next.t('listagemArquivos:history.unknownNewName')}</span>
        </FileNameContainer>
      </FilesContentContainer>
    )
  },
  [HistoryFileActionEnum.DescriptionUpdated]: ({ item }) => {
    return (
      <FilesContentContainer>
        <FileDescriptionContainer>
          <span className="assistantText">{item.To?.DisplayValue}</span>
        </FileDescriptionContainer>
        <FileDescriptionContainer isdisabled="true">
          <span className="assistantText">{item.From?.DisplayValue}</span>
        </FileDescriptionContainer>
        <FileNameContainer>
          <Icon
            icon={iconFileByFilename(item.ItemName)}
            customSize={12}
            className="assitantIcon"
          />
          <span className="assistantText">{item.ItemName}</span>
        </FileNameContainer>
      </FilesContentContainer>
    )
  },
  [HistoryFileActionEnum.FileCreated]: ({ item }) => {
    return (
      <FilesContentContainer>
        <FileMoveContainer>
          <div className="header">
            <FileNameContainer>
              <Icon
                icon={getDisciplineIcon(item.ParentName)}
                customSize={12}
                className="assitantIcon"
              />
              <span className="assistantText">{item.ParentName}</span>
            </FileNameContainer>
          </div>
          <div className="footer">
            <CurveLink><div className="curve" /></CurveLink>
            <FileNameContainer>
              <Icon
                icon={iconFileByFilename(item.ItemName)}
                customSize={12}
                className="assitantIcon"
              />
              <span className="assistantText">{item.ItemName}</span>
            </FileNameContainer>
          </div>
        </FileMoveContainer>
      </FilesContentContainer>
    )
  },
  [HistoryFileActionEnum.FileVersionAdded]: ({ item }) => {
    return (
      <FilesContentContainer>
        <FilesStatusContainer>
          <span className="title">{i18next.t('listagemArquivos:history.revisionPrefix')}</span>
          <FileStatusValue isbloqued="true" isold="true">
            {item.From?.DisplayValue}
          </FileStatusValue>
          <Icon
            icon="rightArrow"
            customSize={16}
            className="arrowIcon"
          />
          <FileStatusValue isbloqued="true" isvariant="revision">
            {item.To?.DisplayValue}
          </FileStatusValue>
        </FilesStatusContainer>
        <FileNameContainer>
          <Icon
            icon={iconFileByFilename(item.ItemName)}
            customSize={12}
            className="assitantIcon"
          />
          <span className="assistantText">{item.ItemName}</span>
        </FileNameContainer>
      </FilesContentContainer>
    )
  },
  [HistoryFileActionEnum.FileRendered]: ({ item }) => {
    const isOldRendering = typeof item.From.DisplayValue === 'string'
      ? item.From.DisplayValue?.toLowerCase()?.includes('renderizando')
      : (item.From?.DisplayValue as string[] || [])?.includes('renderizando') || false;
    const isNewRendering = typeof item.To.DisplayValue === 'string'
      ? item.To.DisplayValue?.toLowerCase()?.includes('renderizando')
      : (item.To?.DisplayValue as string[] || [])?.includes('renderizando') || false;

    return (
      <FilesContentContainer>
        <FilesStatusContainer>
          <span className="title">{i18next.t('listagemArquivos:history.visualizationPrefix')}</span>
          <FileStatusValue
            isbloqued={`${!item?.From?.DisplayValue}`}
            isold="true"
            isvariant={isOldRendering ? 'render' : undefined}
          >
            {item.From?.DisplayValue || i18next.t('sharedModals:common.empty')}
          </FileStatusValue>
          <Icon
            icon="rightArrow"
            customSize={16}
            className="arrowIcon"
          />
          <FileStatusValue isvariant={isNewRendering ? 'render' : undefined}>
            {item.To?.DisplayValue || i18next.t('sharedModals:common.empty')}
          </FileStatusValue>
        </FilesStatusContainer>
        <FileNameContainer>
          <Icon
            icon={iconFileByFilename(item.ItemName)}
            customSize={12}
            className="assitantIcon"
          />
          <span className="assistantText">{item.ItemName}</span>
        </FileNameContainer>
      </FilesContentContainer>
    )
  },
  // [HistoryFileActionEnum.obsolet]: ({ item }) => {
  //   return (
  //     <FilesContentContainer>
  //       <FileMoveContainer>
  //         <div className="header">
  //           <FileNameContainer>
  //             <Icon
  //               icon={getDisciplineIcon(item.parent)}
  //               customSize={12}
  //               className="assitantIcon"
  //             />
  //             <span className="assistantText">{item.parent}</span>
  //           </FileNameContainer>
  //         </div>
  //         <div className="footer">
  //           <CurveLink><div className="curve" /></CurveLink>
  //           <FileNameContainer>
  //             <Icon
  //               icon={iconFileByFilename(item.where)}
  //               customSize={12}
  //               className="assitantIcon"
  //             />
  //             <span className="assistantText">{item.where}</span>
  //           </FileNameContainer>
  //         </div>
  //       </FileMoveContainer>
  //     </FilesContentContainer>
  //   )
  // },
};
